import type { ContentWithLink } from '@/types/feed-entrys';

/**
 * Checks whether the given item has a valid link setup.
 * @param item - Content item to check.
 * @returns True if the link and related CTA properties are valid.
 */
export function hasValidLink(item: ContentWithLink): boolean {
  const hasLinkType = !!item.linkType;
  const hasCta = !!item.cta_text && !!item.cta_type;

  if (!hasLinkType && !hasCta) {
    return false;
  }

  const hasMissingCtaLink = item.cta_type === 'link' && !item.cta_link;
  const hasMissingLink = item.linkType === 'link' && !item.link;
  const hasUnknownType =
    item.linkType === 'unknown' && !item.link?.startsWith('/');

  if (hasMissingCtaLink || hasMissingLink || hasUnknownType) {
    return false;
  }

  return true;
}
